import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { Window } from '@progress/kendo-react-dialogs';
import { connect } from '@common/components/base.component';
import windowActions from '@common/store/window/window.actions';

class WindowComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      top: 0,
      left: 50,
      width: 900,
      height: 647,
      initialLeft: 0,
      initialTop: 50,
    };

    this.windowRef = React.createRef();
    autoBind(this);
  }

  toggleWindow() {
    this.setState({
      showWindow: !this.state.showWindow,
    });
  }

  closeWindow() {
    this.setState({
      visibleWindow: !this.state.visibleWindow,
    });
  }

  resizable() {
    let sizeWidth = this.state.left + this.state.width / 4;
    let percentWidth = (sizeWidth / 100) * 1.5;
    sizeWidth = sizeWidth + percentWidth;

    let sizeHeight = this.state.top + this.state.height / 4;
    let percentHeight = (sizeHeight / 100) * 1.5;
    sizeHeight = sizeHeight + percentHeight;

    if (sizeWidth > window.innerWidth) {
      this.setState({
        left: window.innerWidth - percentWidth - this.state.width / 4,
      });
    }

    if (sizeHeight > window.innerHeight) {
      this.setState({
        top: window.innerHeight - percentHeight - this.state.height / 4,
      });
    }
  }

  handleMove(event) {
    this.setState({
      left: event.left,
      top: event.top,
    });

    if (event.end) {
      this.resizable();
    }
  }

  // TODO: Refatorar atribuição de classes col do boostrap
  handleResize(event) {
    const width = this.state.width;
    $(document).ready(function () {
      if ((width && event.width > 768 && width <= 768) || (event.width < 768 && width >= 768)) {
        const colsSm = $('.k-state-focused').find('[class*=col-sm]');

        let i;
        for (i = 0; i < colsSm.length; i++) {
          // SM
          var smClass = /col-sm-(?<size>\d{1,2})/;
          var matchSm = smClass.exec(colsSm[i].className);
          const sizeSm = matchSm && matchSm.groups && matchSm.groups['size'];
          // LG
          var classLg = /col-lg-(?<size>\d{1,2})/;
          var matchLg = classLg.exec(colsSm[i].className);
          const sizeLg = matchLg && matchLg.groups && matchLg.groups['size'];

          colsSm[i].classList.replace(`col-sm-${sizeSm}`, `col-sm-${sizeLg}`);
          colsSm[i].classList.replace(`col-lg-${sizeLg}`, `col-lg-${sizeSm}`);
        }
      }
    });

    this.setState({
      left: event.left,
      top: event.top,
      width: event.width,
      height: event.hight,
    });
  }

  componentDidMount() {
    this.handleModalCenter();
  }

  handleModalCenter() {
    let windowContainer = this.windowRef.current;
    let windowWidth = windowContainer.width;
    let windowHeight = windowContainer.height;

    let mainContainer = $('body');
    let mainLeft = mainContainer.offset().left;
    let mainWidth = mainContainer.width();
    let mainTop = mainContainer.offset().left;
    let mainHeight = mainContainer.height();

    // Calcula o offset da esquerda
    // posição esquerda + metade da largura do content - metade da largura da tela
    let left = mainLeft + mainWidth / 2 - windowWidth / 2;

    // Calcula o offset do topo
    // posição topo + metade da altura do content - metade da altura da tela
    let top = mainTop + mainHeight / 2 - windowHeight / 2;

    this.setState({ left, top });
  }

  render() {
    let { setHighlighted } = this.props.windowActions;
    const {
      component,
      title,
      initialWidth,
      initialHeight,
      maxWidth,
      minWidth,
      minHeight,
      isResizable,
      windowStage,
      closeWindow,
      id,
      highlighted,
    } = this.props;

    // TODO: Inserir transition para suavizar o reposicionamento da janela quando for arrastado para fora da tela.
    return (
      <div onClick={() => setHighlighted(id)}>
        <Window
          id={id}
          key={id}
          title={title}
          top={this.state.top}
          left={this.state.left}
          maxWidth={maxWidth}
          minWidth={minWidth}
          minHeight={minHeight}
          resizable={isResizable}
          windowStage={windowStage}
          onMove={this.handleMove}
          onResize={this.handleResize}
          initialWidth={initialWidth}
          initialHeight={initialHeight}
          initialLeft={this.state.initialLeft}
          initialTop={this.state.initialTop}
          ref={this.windowRef}
          style={{ zIndex: highlighted ? '99999' : '999' }}
          onClose={() => {
            closeWindow(id);
          }}
        >
          {component}
        </Window>
      </div>
    );
  }
}

export default connect({
  selectors: {},
  actions: {
    windowActions,
  },
})(WindowComponent);
